export enum CommissionType {
    Absolute = 0,
    Percentage = 1
}
